module.exports = __webpack_public_path__ + "img/55ne.30a5c062.svg";